import { render, staticRenderFns } from "./formdialogsp_medicalSchool.vue?vue&type=template&id=b2f5ed48&scoped=true"
import script from "./formdialogsp_medicalSchool.vue?vue&type=script&lang=js"
export * from "./formdialogsp_medicalSchool.vue?vue&type=script&lang=js"
import style0 from "./formdialogsp_medicalSchool.vue?vue&type=style&index=0&id=b2f5ed48&prod&lang=css"
import style1 from "./formdialogsp_medicalSchool.vue?vue&type=style&index=1&id=b2f5ed48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f5ed48",
  null
  
)

export default component.exports